import { Fragment, ReactNode } from 'react';
import { Transition, Dialog } from '@headlessui/react';
import Container from './Container';
import { H4 } from './Typography';
import CloseButton from './Buttons/components/CloseButton';
import UserDropdown from 'src/layouts/dashboard-layout/UserDropdown';

enum ModalVariant {
  'fullscreen',
  'center'
}

type ModalProps = {
  isOpen: boolean;
  closeModal: () => void;
  children: ReactNode;
  title?: string | null;
  icon?: string;
  isAuth?: boolean;
  variant?: keyof typeof ModalVariant;
};

const Modal = ({
  isOpen,
  closeModal,
  children,
  title,
  icon = 'clarity:window-close-line',
  variant = 'fullscreen',
  isAuth
}: ModalProps) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={closeModal}>
        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center text-center">
            <Transition.Child
              as={Fragment}
              enter="transition ease-in-out duration-300 transform"
              enterFrom="-translate-y-full"
              enterTo="translate-y-0"
              leave="transition ease-in-out duration-300 transform"
              leaveFrom="translate-y-0"
              leaveTo="-translate-y-full"
            >
              <Dialog.Panel className="w-full min-h-screen transform overflow-hidden bg-white text-left align-middle shadow-xl transition-all">
                <header className="relative py-6 border-b border-[#F3F7FF] h-24">
                  <Container>
                    <div className="flex relative justify-between items-center">
                      <div className="flex-1">
                        <CloseButton icon={icon} onClick={closeModal} />
                      </div>
                      <div className="flex-1 text-center">
                        {title && (
                          <H4 className="text-base sm:text-2x"> {title}</H4>
                        )}
                      </div>
                      <div className="flex-1 text-center">
                        {isAuth && <UserDropdown />}
                      </div>
                    </div>
                  </Container>
                </header>
                <Transition.Child
                  as={Fragment}
                  enter="transition ease-in-out duration-300 transform"
                  enterFrom="-translate-x-full"
                  enterTo="translate-y-0"
                  leave="transition ease-in-out duration-300 transform"
                  leaveFrom="translate-y-0"
                  leaveTo="-translate-x-full"
                >
                  <div className="relative min-h-[calc(100vh-96px)] pb-10">
                    {children}
                  </div>
                </Transition.Child>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default Modal;
